import type { TFunction } from 'i18next';
import type { ProcessExecuteIntervalType, ProcessIntervalAnchor } from '@econtractor/types';

const plainIntervalText = (text: string): string => text.replace(/<[^>]+>/g, '');

export const formatProcessInterval = (
    interval: ProcessExecuteIntervalType | null,
    t: TFunction,
    anchor?: ProcessIntervalAnchor | null,
): string => {
    if (interval?.unit === 'byCoreTask') return t('processDiagram.intervalByCore');
    const fromDeadline = anchor === 'deadline';
    if (!interval || interval.value === 0) {
        return plainIntervalText(fromDeadline
            ? t('processDiagram.intervalInstantFromDeadline')
            : t('processDiagram.intervalInstant'));
    }
    return plainIntervalText(t(
        fromDeadline ? 'processDiagram.intervalOnFromDeadline' : 'processDiagram.intervalOnFromAccept',
        {
            value: interval.value,
            unit: t(`processDiagram.unitsOn.${interval.unit}`),
        },
    ));
};
